import {
  MonthViewOptions
} from '../models';

export const defaultMonthOptions: MonthViewOptions = {
  width: 7,
  height: 6
};

export const dayInMilliseconds = 24 * 60 * 60 * 1000;
